
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import timelineElements from "./timelineElements";
import "./TimeLine.css";




import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";

import "react-vertical-timeline-component/style.min.css";

function TimeLine(props){

   




    let timelineElements=props.myarray.reverse();

   


    function formatDate(string) {
      var options = { year: "numeric", month: "long", day: "numeric",hour:"numeric", minute:"numeric", second:"numeric"};
      return new Date(string).toLocaleDateString([], options);
    }


  return (
    <div>
      <VerticalTimeline
            lineColor="#D9D9D9" 
            animate={false}>
      {timelineElements.map(element => {

          return (
            <VerticalTimelineElement
              position="right"
              key={element.key}
              date={formatDate(element.created)}
              dateClassName="date"
              contentStyle={ {"background":"#F8F8F8","boxShadow":"none", "paddingLeft":"0rem!important","marginTop":"-3rem","marginBottom":"-12rem","paddingBottom": "0.1rem!important","color":" #0B5BF8"}}
              contentArrowStyle={{"border":"none", }}
              iconStyle={{"background":"#FFB600","width":"1.3rem","height":"1.3rem","marginLeft":"-0.4rem", "marginTop":"1rem","boxShadow":"none"}}
              >
              <h3 className="vertical-timeline-element-title">
                {element.applicationStatus}
              </h3>
              {/* <h5 className="vertical-timeline-element-subtitle">
                {element.location}
              </h5> */}
              {/* <p id="description">{element.description}</p> */}
            </VerticalTimelineElement>
          )
        })}
      </VerticalTimeline>
    </div>
  )
}

export default TimeLine;